import React from 'react';
import * as guidelineHelper from './guidelines_utils';
import CampaignContentGuidelineItem from './campaign_content_guideline_item';

const CampaignContentGuidelinesSection = ({guidelines}) => {
    const {must, mustNot} = guidelineHelper.getMustAndMustNotGuidelines(guidelines);

    return (
        <div className="campaign-guidelines-section">
            {must.map((guideline) => (
                <CampaignContentGuidelineItem
                    key={guideline.position}
                    description={guideline.description}
                    must
                />
            ))}

            {mustNot.map((guideline) => (
                <CampaignContentGuidelineItem
                    key={guideline.position}
                    description={guideline.description}
                    must={false}
                />
            ))}
        </div>
    )
}

export default CampaignContentGuidelinesSection;



// WEBPACK FOOTER //
// ./components/campaign_content_guidelines/campaign_content_guidelines_section.js